import React, { useState, useRef } from 'react';
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import Maybe from 'components/__new/common/Maybe';

const PayrollDatePicker = (props) => {
    const {
        renderMonthContent,
        onChange,
        label,
        required,
        rightIcon,
        rightIconClass,
        rightIconClicked,
        containerClass,
        inputClass,
        selected,
        placeholderText
    } = props;
    const datePickerRef = useRef(null);
    
    const handleIconClick = () => {
        if (!datePickerRef.current) return;
        datePickerRef.current?.setFocus();
    }

    return (
        <div className={`form-group ${containerClass || ""}`}>
            <Maybe condition={label !== "" && label !== " "}>
                <label>
                    {label || ""}
                    <Maybe condition={required === true}>
                        <span className="form-input-required">*</span>
                    </Maybe>
                </label>
            </Maybe>

            <div className='relative'>
                <DatePicker
                    selected={selected}
                    renderMonthContent={renderMonthContent}
                    showMonthYearPicker
                    dateFormat="MMMM, yyyy"
                    placeholderText={placeholderText}
                    className={`
                        ${rightIcon ? "pr-10" : ""}
                        form-input ${inputClass || ""}
                    `}
                    onChange={onChange}
                    ref={datePickerRef}
                />
                <Maybe condition={rightIcon}>
                    <div className={`${rightIconClass} w-max h-full flex justify-center items-center absolute top-0 right-0 text-gray-500 cursor-pointer`} onClick={handleIconClick}>
                        {rightIcon}
                    </div>
                </Maybe>
            </div>
        </div>
    )
}

export default PayrollDatePicker